import React, { useState, useEffect } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import adminService from '../../services/AdminService';

const UserDetailsModal = (props) => {

    const { show, onHide, userId } = props;

    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
    const [errorText, setErrorText] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);

    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        if (!userDetails) {
            adminService.getUserDetails(userId).then((userDetails) => {
                setUserDetails(userDetails);
            });
        }
    }, [userDetails])

    let errorLabel = errorText && errorText.length > 0 ? <span className="text-danger">{errorText}</span> : <></>;
    let successLabel = showSuccess ? <span className="text-success">Password updated</span> : <></>;

    if (userDetails) {
        return <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3>
                        {userDetails.firstname} {userDetails.lastname}
                    </h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md="4">Email:</Col>
                    <Col md="8">{userDetails.email}</Col>
                </Row>
                <Row>
                    <Col md="4">Activated:</Col>
                    <Col md="8">{userDetails.activated ? 'true' : 'false'}</Col>
                </Row>
                <Row>
                    <Col md="4">Role:</Col>
                    <Col md="8">{userDetails.roleName}</Col>
                </Row>
                <Row>
                    <Col>
                        {(userDetails && !userDetails.activated) && <Button
                            variant="outline-secondary"
                            onClick={async (clickInfo) => {
                                if (userDetails) {
                                    await adminService.activate(userId)
                                    let user = await adminService.getUserDetails(userId);
                                    setUserDetails(user);
                                }
                            }}>Activate</Button>}
                        {(userDetails && userDetails.activated) && <Button
                            variant="outline-secondary"
                            onClick={async (clickInfo) => {
                                if (userDetails) {
                                    await adminService.deactivate(userId)
                                    let user = await adminService.getUserDetails(userId);
                                    setUserDetails(user);
                                }
                            }}>Deactivate</Button>}
                    </Col>
                </Row>

                <hr></hr>
                <h4>Change Password</h4>
                <Row>
                    <Col>
                        <Form.Label htmlFor="newPasswordInput">Enter new password</Form.Label>
                        <Form.Control
                            id="newPasswordInput"
                            type="password"
                            value={newPassword ? newPassword : ''}
                            onChange={(event) => {
                                setNewPassword(event.target.value);
                            }}
                            placeholder="Enter password" />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label htmlFor="newPasswordConfirmInput">Confirm new password</Form.Label>
                        <Form.Control
                            id="newPasswordConfirmInput"
                            type="password"
                            value={newPasswordConfirm ? newPasswordConfirm : ''}
                            onChange={(event) => {
                                setNewPasswordConfirm(event.target.value);
                            }}
                            placeholder="Confirm password" />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {errorLabel}
                        {successLabel}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            type="button"
                            variant="primary"
                            className="mt-2"
                            onClick={async () => {
                                setErrorText(null);
                                setShowSuccess(false);

                                try {
                                    var result = await adminService.changePassword(userId, newPassword, newPasswordConfirm);

                                    console.log(result);
                                    setShowSuccess(true);
                                }
                                catch (err) {
                                    console.log(err);
                                    if (err && err.data && err.data.error) {
                                        setErrorText(err.data.error)
                                    } else {
                                        setErrorText('An error occurred')
                                    }
                                }
                            }}>Change Password</Button>
                    </Col>
                </Row>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => {
                    setUserDetails(null);
                    setErrorText(null);
                    setShowSuccess(false);
                    onHide();
                }}>Close</Button>
            </Modal.Footer>
        </Modal>;
    }
    else {
        return <></>;
    }
}

export default UserDetailsModal;